angular.module('surfsightApp.controllers').controller('languageController', [
  '$scope',
  '$http',
  '$filter',
  '$localStorage',
  '$mdDialog',
  '$mdToast',
  '$interval',
  '$translate',
  function (
    $scope,
    $http,
    $filter,
    $localStorage,
    $mdDialog,
    $mdToast,
    $interval,
    $translate
  ) {
    $scope.languagesList = window.languagesList
    $scope.changeLanguage = function (lang) {
      $translate.use(lang.language_key)
      $localStorage.selectedLanguage = lang
      moment.locale(lang.lang_code.toLowerCase())
      // console.log(lang);
      $mdDialog.hide(lang)
    }
    $scope.cancel = function () {
      $mdDialog.cancel()
    }
  }
])
